import { styled } from '@mui/material';

const StyledLayout = styled('div')(() => ({
  maxWidth: '1800px',
  margin: '0 auto',
  padding: '50px 30px',
  overflowX: 'hidden',
}));

export default StyledLayout;
